<div class="whatsapp-preview" *ngIf="user">
  <div class="chat-bubble">
    <div class="chat-header">{{ whatsappTemplateContent.header }}</div>
    <div class="chat-body" [innerHTML]="whatsappTemplateContent.body"></div>
    <div class="chat-info">
      <span [innerHTML]="whatsappTemplateContent.documentLine"></span><br />
      <span [innerHTML]="whatsappTemplateContent.senderLine"></span>
    </div>
    <div class="chat-footer">
      <span class="chat-note" [innerHTML]="whatsappTemplateContent.footer"></span>
      <span class="chat-timestamp">{{ currentDate.toString() | ldate: 'HH:mm' }}</span>
    </div>
    <hr class="chat-separator" />
    <a href="javascript:void(0)" class="chat-button">
      <span class="chat-note" [innerHTML]="whatsappTemplateContent.buttonText"></span>
    </a>
  </div>
</div>
